import { render, staticRenderFns } from "./small_product_detail.vue?vue&type=template&id=5f9b3414&"
import script from "./small_product_detail.vue?vue&type=script&lang=js&"
export * from "./small_product_detail.vue?vue&type=script&lang=js&"
import style0 from "./small_product_detail.vue?vue&type=style&index=0&id=5f9b3414&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports